import { render, staticRenderFns } from "./ladda_button.vue?vue&type=template&id=4e4d4e18&"
import script from "./ladda_button.vue?vue&type=script&lang=js&"
export * from "./ladda_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports